import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
    InputNumber
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { WalletGroup } from '../../../../types/WalletGroup'

const { TextArea } = Input;
const { Option } = Select;


interface Ledgers {
    ledger_id: number;
    ledger_first_name: string;
    ledger_last_name: string;
    ledger_name: string;
    ledger_occupation: string;
}

type WalletTotal = {
  wallet_type: string;
  total_amount: number;
};



interface WalletModelProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        wallet_id?: number;
        wallet_ledger_id?: string;
        wallet_type?: string;
        wallet_category?: string;
        wallet_remark?: string;
        wallet_amount?: string;
    } | null;
    isEditMode?: boolean;
    LedgerData: {
        ledger_id: string;
        ledger_first_name: string;
        ledger_last_name: string;
    }[];
}

const DepositModel: React.FC<WalletModelProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
    LedgerData=[]
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);
    const [ledgers, setLedgers] = useState<Ledgers[]>([]);
    const [selectedLedger, setSelectedLedger] = useState<number | null>(null);
    const walletType = Form.useWatch("wallet_type", form);
    const [walletbalance, setWalletBalance] = useState<WalletGroup[]>([]);
    
     const [walletGroups, setWalletGroups] = useState<WalletTotal[]>([
        { wallet_type: "TDS", total_amount: 0 },
        { wallet_type: "Reserve Fund", total_amount: 0 },
        { wallet_type: "Other", total_amount: 0 }
    ]);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };
    // async function fetchWalletLedgers() {
    //         try {
    //             const response = await apiRequest({
    //                 method: 'get',
    //                 url: '/wallet-ledgers'   
    //             });

    //             console.log("Wallet Ledger Data:", response);

    //             setLedgers(
    //                 response.ledgers
    //                     .filter((t: any) =>
    //                         t.ledger_first_name &&
    //                         t.ledger_first_name !== "undefined"
    //                     )
    //                     .map((t: any) => ({
    //                         ledger_id: t.ledger_id,
    //                         ledger_name: `${t.ledger_first_name} ${t.ledger_last_name}`
    //                     }))
    //             );

    //         } catch (err) {
    //             showError("Failed to load wallet ledger names");
    //         }
    //     }

    // Handle form submit
    
    
    const handleAddWallet = async (values: any) => {
            try {
                const wallet_entries = [
                {
                    type: values.wallet_type,   // tds | reserve fund | other
                    amount: values.wallet_amount
                }
            ];

            
            const dataVal = {
                wallet_ledger_id: values.wallet_ledger_id,
                wallet_type: values.wallet_type,
                wallet_entries, 
                wallet_remark: values.wallet_remark,
                wallet_amount: values.wallet_amount,
                ...(initialValues?.wallet_id && { wallet_id: initialValues.wallet_id }),
            };
            const url = isEditMode
                ? 'edit-wallet'
                : 'add-deposit-wallet';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess('Deposit wallet successfully!');
            form.resetFields();

            if (isModalClose) {
                onCancel();
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} wallet`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                wallet_ledger_id: initialValues.wallet_ledger_id,
                wallet_type: initialValues.wallet_type,
                wallet_category: initialValues.wallet_category,
                wallet_remark: initialValues.wallet_remark,
                wallet_amount: initialValues.wallet_amount,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);




    return (
        <Modal
            title={isEditMode ? 'Edit wallet' : 'Add New wallet'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddWallet}
                autoComplete="off"
            >
                <Row gutter={16}>
                    {/* ledgers */}
                     <Col span={12}>
                            <Form.Item
                                name="wallet_ledger_id"
                                className='px-8'
                                label={
                                    <span>
                                        Select Ledger
                                    </span>
                                }
                                rules={[{ required: true, message: 'Please select a ledger' }]}
                            >
                                <Select
                                    placeholder="Select ledger"
                                    onChange={(value) => {
                                        form.setFieldsValue({ wallet_ledger_id: value }); // just update form
                                    }}
                                    // value={selectedLedger}
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {LedgerData.map((l) => (
                                        <Option key={l.ledger_id} value={l.ledger_id}>
                                            {l.ledger_first_name} {l.ledger_last_name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    
                    {/* type */}
                    <Col span={12}>
                        <Form.Item
                            name="wallet_type"
                            className='px-8'
                            label={<span>Type</span>}
                            rules={[{ required: true, message: 'Please select wallet type' }]}
                        >
                            <Select placeholder="Select type">
                                <Select.Option value="tds">TDS</Select.Option>
                                <Select.Option value="reserve fund">Reserve Fund</Select.Option>
                                <Select.Option value="other">other</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    {/* tds */}
                    {walletType === "tds" && (
                        <Col span={12}>
                            <Form.Item
                                name="wallet_amount"
                                className="px-8"
                                label="TDS Amount"
                                rules={[
                                    { required: true, message: 'Please enter the wallet tds amount' },
                                    { type: 'number', min: 0.01, message: 'Amount must be greater than zero' },
                                ]}
                            >
                                <InputNumber
                                    min={0}
                                    style={{ width: '100%' }}
                                    placeholder="Enter wallet TDS amount"
                                    controls={false}
                                    parser={(value: string | undefined): number => {
                                        const parsed = value?.replace(/[^\d.]/g, '') ?? '';
                                        return parsed === '' ? 0 : parseFloat(parsed);
                                    }}
                                    formatter={(value: number | string | undefined) =>
                                        value !== undefined ? String(value) : '0'
                                    }
                                    onKeyDown={(e) => {
                                        if (
                                            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End', '.'].includes(
                                                e.key
                                            )
                                        )
                                            return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d*\.?\d*$/.test(paste)) e.preventDefault();
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Reserve Fund Amount */}
                    {walletType === "reserve fund" && (
                        <Col span={12}>
                            <Form.Item
                                name="wallet_amount"
                                className="px-8"
                                label="Reserve Fund Amount"
                                rules={[
                                    { required: true, message: 'Please enter the wallet reserve fund amount' },
                                    { type: 'number', min: 0.01, message: 'Amount must be greater than zero' },
                                ]}
                            >
                                <InputNumber
                                    min={0}
                                    style={{ width: '100%' }}
                                    placeholder="Enter wallet reserve fund amount"
                                    controls={false}
                                    parser={(value: string | undefined): number => {
                                        const parsed = value?.replace(/[^\d.]/g, '') ?? '';
                                        return parsed === '' ? 0 : parseFloat(parsed);
                                    }}
                                    formatter={(value: number | string | undefined) =>
                                        value !== undefined ? String(value) : '0'
                                    }
                                    onKeyDown={(e) => {
                                        if (
                                            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End', '.'].includes(
                                                e.key
                                            )
                                        )
                                            return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d*\.?\d*$/.test(paste)) e.preventDefault();
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Others Amount */}
                    {walletType === "other" && (
                        <Col span={12}>
                            <Form.Item
                                name="wallet_amount"
                                className="px-8"
                                label="other Amount"
                                rules={[
                                    { required: true, message: 'Please enter the wallet other amount' },
                                    { type: 'number', min: 0.01, message: 'Amount must be greater than zero' },
                                ]}
                            >
                                <InputNumber
                                    min={0}
                                    style={{ width: '100%' }}
                                    placeholder="Enter wallet other amount"
                                    controls={false}
                                    parser={(value: string | undefined): number => {
                                        const parsed = value?.replace(/[^\d.]/g, '') ?? '';
                                        return parsed === '' ? 0 : parseFloat(parsed);
                                    }}
                                    formatter={(value: number | string | undefined) =>
                                        value !== undefined ? String(value) : '0'
                                    }
                                    onKeyDown={(e) => {
                                        if (
                                            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End', '.'].includes(
                                                e.key
                                            )
                                        )
                                            return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d*\.?\d*$/.test(paste)) e.preventDefault();
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* remark */}
                    <Col span={12}>
                        <Form.Item
                            name="wallet_remark"
                            className='px-8'
                            label={
                                <span>
                                    Remark&nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 255 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the wallet remark' },
                                { max: 255, message: 'Maximum 255 characters allowed' },
                            ]}
                        >
                            <Input.TextArea
                                showCount
                                maxLength={255}
                                placeholder="e.g., wallet remark"
                                autoSize={{ minRows: 3, maxRows: 6 }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <div style={{ background: "#f5f5f5", padding: 15, borderRadius: 6, marginBottom: 20 }}>
                            <h3>Wallet Summary</h3>
                            {walletbalance.map((g) => (
                            <p key={g.wallet_type}>
                                <strong style={{ textTransform: "capitalize" }}>{g.wallet_type}:</strong> ₹{g.final_balance}
                            </p>
                            ))}

                            <hr />
                            <p>
                            <strong>Total:</strong> ₹
                            {walletbalance
                                .reduce((sum, g) => sum + Number(g.final_balance || 0), 0)
                                .toFixed(2)}
                            </p>
                        </div>
                    </Col>

                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Wallet
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DepositModel;
